import React, { FC } from "react";
import { AccordionDetailsProps } from "@mui/material";

import { StyledMuiAccordionDetails } from "./styled";

export interface IStyledAccordionDetailsProps extends AccordionDetailsProps {}

export const StyledAccordionDetails: FC<IStyledAccordionDetailsProps> = props => {
  const { children, ...rest } = props;

  return <StyledMuiAccordionDetails {...rest}>{children}</StyledMuiAccordionDetails>;
};
